import React, { FC } from "react";

import UILoader from "./Loader";
import { FullSectionLoaderContainer } from "./styles";

interface FullSectionLoaderProps {
  className?: string;
}

const FullSectionLoader: FC<FullSectionLoaderProps> = ({ className }) => (
  <FullSectionLoaderContainer data-testid="section-loader" className={className}>
    <UILoader />
  </FullSectionLoaderContainer>
);

export default FullSectionLoader;
